import { useState } from 'react';

// Custom hook pro použití fází v konfigurátoru - aktivní fáze + možnosti změnit aktivní fázi
export const usePhase = (phases, initPhaseId) => {
    const [activePhase, setActivePhase] = useState(initPhaseId || (phases ? phases[0] : null));

    const setNextPhase = () => {
        setActivePhase((prevActivePhase) => {
            const nextPhaseIndex = prevActivePhase.order + 1;

            if (nextPhaseIndex >= phases.length) {
                console.error('Cannot set next phase! This is last phase.');
                return prevActivePhase;
            }

            return phases[nextPhaseIndex];
        });
    };

    const setPrevPhase = () => {
        setActivePhase((prevActivePhase) => {
            const prevPhaseIndex = prevActivePhase.order - 1;

            if (prevPhaseIndex < 0) {
                console.error('Cannot set prev phase! This is first phase.');
                return prevActivePhase;
            }

            return phases[prevPhaseIndex];
        });
    };

    const setSpecificPhase = (phaseId) => {
        const phase = phases.find((phase) => phase.id === phaseId);

        if (!phase) {
            console.error(`Cannot find phase with id: ${phaseId}`);
            return;
        }

        setActivePhase(phase);
    };

    return { activePhase, setNextPhase, setPrevPhase, setSpecificPhase };
};
